import util from '../util';

export const AUTH = 'AUTH';
export const REDIRECT = 'REDIRECT';
export const ACCESS_DEALER = 'ACCESS_DEALER';
export const ACCESS_ADMIN = 'ACCESS_ADMIN';
export const LOGOUT = 'LOGOUT';
export const OTP_VERIFY = 'OTP_VERIFY';
export const OTP_RESEND = 'OTP_RESEND';
export const EXPIRE_SESSION = 'EXPIRE_SESSION';
export const OKTA_REDIRECT = 'OKTA_REDIRECT';

export const AUTH_REQUEST = util.requestType(AUTH);
export const AUTH_SUCCESS = util.successType(AUTH);
export const AUTH_FAILURE = util.failureType(AUTH);

export const REDIRECT_REQUEST = util.requestType(REDIRECT);

export const ACCESS_DEALER_REQUEST = util.requestType(ACCESS_DEALER);
export const ACCESS_DEALER_SUCCESS = util.successType(ACCESS_DEALER);
export const ACCESS_DEALER_FAILURE = util.failureType(ACCESS_DEALER);

export const ACCESS_ADMIN_REQUEST = util.requestType(ACCESS_ADMIN);
export const ACCESS_ADMIN_SUCCESS = util.successType(ACCESS_ADMIN);
export const ACCESS_ADMIN_FAILURE = util.failureType(ACCESS_ADMIN);

export const LOGOUT_REQUEST = util.requestType(LOGOUT);

export const OTP_VERIFY_REQUEST = util.requestType(OTP_VERIFY);
export const OTP_RESEND_REQUEST = util.requestType(OTP_RESEND);

export const EXPIRE_SESSION_REQUEST = util.requestType(EXPIRE_SESSION);
